import { render, staticRenderFns } from "./LuTrackedBillPermission.vue?vue&type=template&id=22a1f7e2"
import script from "./LuTrackedBillPermission.vue?vue&type=script&lang=js"
export * from "./LuTrackedBillPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports